<app-load-nav [activeMenuItem]="'white-listed-senders'"></app-load-nav>


<mat-card class="content-card">

  <app-mat-table-generator #table
                           [saveFilters]=true
                           tableName="whiteListedSendersTable"
                           [useEmbededFilter]="true"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="deleteEnabled()"
                           [customActions]="customActions"
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           [defaultSortField] = "'date'"
                           [defaultSortDirection]="'desc'"
  >
  </app-mat-table-generator>
</mat-card>

